import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Tag, Pencil, Check } from "lucide-react";

// Community-edit review list. Presentational: state + handlers come from the parent.
export const EditedTab = ({ edited, openEdit, markReviewed }) => {
  if (edited.length === 0) {
    return <p className="text-muted-foreground">No community edits awaiting review.</p>;
  }
  return (
    <div className="space-y-3">
      {edited.map((d) => (
        <div key={d.deal_id} data-testid={`edited-${d.deal_id}`} className="flex items-center gap-4 rounded-xl border border-black/10 bg-white p-4">
          {d.image_url ? (
            <img src={d.image_url} alt="" className="h-16 w-16 rounded-lg object-cover shrink-0" />
          ) : (
            <div className="h-16 w-16 rounded-lg bg-secondary flex items-center justify-center shrink-0">
              <Tag className="h-5 w-5 text-muted-foreground" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <StatusBadge status={d.status} />
              <span className="text-xs text-muted-foreground">edited by {d.last_edited_by_name || "submitter"}</span>
            </div>
            <h3 className="mt-1 font-heading text-lg truncate" style={{ fontWeight: 600 }}>{d.title}</h3>
            <p className="text-xs text-muted-foreground">
              {d.retailer} · last edited {(d.last_community_edit_at || d.updated_at || "").slice(0, 16).replace("T", " ")} · {d.edit_count || 1} edit(s)
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button variant="outline" size="sm" data-testid={`edit-edited-${d.deal_id}`} onClick={() => openEdit(d)} className="rounded-full border-black/20">
              <Pencil className="mr-1 h-3.5 w-3.5" /> Review &amp; edit
            </Button>
            <Button size="sm" data-testid={`mark-reviewed-${d.deal_id}`} onClick={() => markReviewed(d.deal_id)} className="rounded-full">
              <Check className="mr-1 h-3.5 w-3.5" /> Reviewed
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditedTab;
